var map = {
	"./apple_pie.png": 7690,
	"./baked_apple.png": 3821,
	"./baked_fortified_pumpkin.png": 5724,
	"./baked_golden_apple.png": 235,
	"./baked_palm_fruit.png": 1202,
	"./baked_sun_pumpkin.png": 7838,
	"./blackened_crab.png": 7729,
	"./bright_elixir.png": 951,
	"./buttered_stambulb.png": 5619,
	"./campfire_egg.png": 3624,
	"./carrot_cake.png": 9621,
	"./carrot_stew.png": 2072,
	"./charred_pepper.png": 1589,
	"./cheesecake.png": 950,
	"./cheesy_baked_fish.png": 8121,
	"./cheesy_curry.png": 4706,
	"./cheesy_meat_bowl.png": 5671,
	"./cheesy_omelet.png": 1059,
	"./cheesy_risotto.png": 8779,
	"./cheesy_tomato.png": 197,
	"./chilly_elixir.png": 9170,
	"./cooked_stambulb.png": 1569,
	"./copious_fried_wild_greens.png": 9638,
	"./copious_meat_skewers.png": 2998,
	"./copious_mushroom_skewers.png": 5565,
	"./copious_seafood_skewers.png": 6476,
	"./copious_simmered_fruit.png": 7659,
	"./crab_omelet_with_rice.png": 9481,
	"./crab_risotto.png": 6834,
	"./crab_stir_fry.png": 5152,
	"./cream_of_mushroom_soup.png": 1862,
	"./cream_of_vegetable_soup.png": 6781,
	"./creamy_heart_soup.png": 9917,
	"./creamy_meat_soup.png": 1974,
	"./creamy_seafood_soup.png": 6986,
	"./crunchy_fried_rice.png": 2592,
	"./curry_pilaf.png": 7723,
	"./curry_rice.png": 5334,
	"./dark_cake.png": 3818,
	"./dark_curry.png": 3401,
	"./dark_rice_ball.png": 789,
	"./dark_soup.png": 7351,
	"./dark_stew.png": 6483,
	"./deep_fried_bird_roast.png": 1034,
	"./deep_fried_drumstick.png": 7309,
	"./deep_fried_thigh.png": 6425,
	"./dubious_food.png": 1997,
	"./egg_pudding.png": 6904,
	"./egg_tart.png": 8960,
	"./electro_elixir.png": 9131,
	"./enduring_elixir.png": 5485,
	"./energizing_elixir.png": 5553,
	"./fairy_tonic.png": 1380,
	"./fireproof_elixir.png": 857,
	"./fish_and_mushroom_skewer.png": 8658,
	"./fish_pie.png": 1052,
	"./fish_skewer.png": 5727,
	"./fragrant_mushroom_saute.png": 3222,
	"./fragrant_seafood_stew.png": 460,
	"./fried_bananas.png": 5836,
	"./fried_egg_and_rice.png": 819,
	"./fried_wild_greens.png": 6333,
	"./frozen_arowana.png": 7881,
	"./frozen_bass.png": 7689,
	"./frozen_bird_drumstick.png": 8176,
	"./frozen_bird_thigh.png": 2348,
	"./frozen_carp.png": 2078,
	"./frozen_cave_fish.png": 2830,
	"./frozen_crab.png": 766,
	"./frozen_hearty_bass.png": 923,
	"./frozen_hearty_salmon.png": 8300,
	"./frozen_porgy.png": 8093,
	"./frozen_river_snail.png": 9882,
	"./frozen_trout.png": 6488,
	"./frozen_whole_bird.png": 2837,
	"./fruit_and_mushroom_mix.png": 4679,
	"./fruit_pie.png": 9680,
	"./fruitcake.png": 9371,
	"./fruity_tomato_stew.png": 4019,
	"./glazed_meat.png": 4190,
	"./glazed_mushrooms.png": 7350,
	"./glazed_seafood.png": 5538,
	"./glazed_veggies.png": 4661,
	"./gourmet_cheesy_meat_bowl.png": 161,
	"./gourmet_meat_and_rice_bowl.png": 5467,
	"./gourmet_meat_and_seafood_fry.png": 5332,
	"./gourmet_meat_curry.png": 7538,
	"./gourmet_meat_stew.png": 162,
	"./gourmet_poultry_curry.png": 532,
	"./gourmet_poultry_pilaf.png": 5891,
	"./gourmet_spiced_meat_skewer.png": 1859,
	"./hard_boiled_egg.png": 9988,
	"./hasty_elixir.png": 5708,
	"./hearty_elixir.png": 1184,
	"./herb_saute.png": 7285,
	"./honey_candy.png": 1270,
	"./honey_crepe.png": 1600,
	"./honeyed_apple.png": 3526,
	"./honeyed_fruits.png": 1425,
	"./hot_buttered_apple.png": 7973,
	"./hylian_tomato_pizza.png": 3092,
	"./icy_gourmet_meat.png": 6938,
	"./icy_meat.png": 4,
	"./icy_prime_meat.png": 5628,
	"./meat_and_mushroom_skewer.png": 8549,
	"./meat_and_rice_bowl.png": 5321,
	"./meat_and_seafood_fry.png": 4614,
	"./meat_curry.png": 5436,
	"./meat_pie.png": 3371,
	"./meat_skewer.png": 1942,
	"./meat_stew.png": 3660,
	"./meat_stuffed_pumpkin.png": 3005,
	"./meaty_rice_balls.png": 1884,
	"./melty_cheesy_bread.png": 9159,
	"./mighty_elixir.png": 9765,
	"./milk.png": 1948,
	"./monster_cake.png": 968,
	"./monster_curry.png": 6335,
	"./monster_rice_balls.png": 6740,
	"./monster_soup.png": 581,
	"./monster_stew.png": 1873,
	"./mushroom_omelet.png": 9576,
	"./mushroom_rice_balls.png": 8972,
	"./mushroom_risotto.png": 8098,
	"./mushroom_skewer.png": 711,
	"./noble_pursuit.png": 9746,
	"./nutcake.png": 5796,
	"./omelet.png": 5021,
	"./pepper_seafood.png": 6637,
	"./pepper_steak.png": 4022,
	"./plain_crepe.png": 8937,
	"./porgy_meuniere.png": 3425,
	"./poultry_curry.png": 7162,
	"./poultry_pilaf.png": 3305,
	"./prime_cheesy_meat_bowl.png": 3687,
	"./prime_meat_and_rice_bowl.png": 2361,
	"./prime_meat_and_seafood_fry.png": 8118,
	"./prime_meat_curry.png": 8236,
	"./prime_meat_stew.png": 5452,
	"./prime_poultry_curry.png": 8282,
	"./prime_poultry_pilaf.png": 6089,
	"./prime_spiced_meat_skewer.png": 6597,
	"./pumpkin_pie.png": 6058,
	"./pumpkin_stew.png": 2171,
	"./roasted_acorn.png": 2115,
	"./roasted_armoranth.png": 312,
	"./roasted_arowana.png": 7255,
	"./roasted_bass.png": 791,
	"./roasted_big_radish.png": 7448,
	"./roasted_bird_drumstick.png": 622,
	"./roasted_bird_thigh.png": 5086,
	"./roasted_carp.png": 7720,
	"./roasted_cave_fish.png": 7464,
	"./roasted_endura_carrot.png": 7127,
	"./roasted_hearty_bass.png": 5269,
	"./roasted_hearty_salmon.png": 3782,
	"./roasted_hydromelon.png": 4373,
	"./roasted_hylian_tomato.png": 6622,
	"./roasted_lotus_seeds.png": 7414,
	"./roasted_mighty_bananas.png": 9075,
	"./roasted_mighty_thistle.png": 6232,
	"./roasted_porgy.png": 7887,
	"./roasted_radish.png": 1673,
	"./roasted_swift_carrot.png": 9787,
	"./roasted_tree_nut.png": 1642,
	"./roasted_trout.png": 8782,
	"./roasted_voltfruit.png": 1965,
	"./roasted_whole_bird.png": 8915,
	"./roasted_wildberry.png": 88,
	"./rock_hard_food.png": 1081,
	"./salmon_meuniere.png": 7742,
	"./salmon_risotto.png": 3306,
	"./salt_grilled_crab.png": 5166,
	"./salt_grilled_fish.png": 2526,
	"./salt_grilled_gourmet_meat.png": 535,
	"./salt_grilled_greens.png": 7456,
	"./salt_grilled_meat.png": 9745,
	"./salt_grilled_mushrooms.png": 2531,
	"./salt_grilled_prime_meat.png": 2793,
	"./sauteed_nuts.png": 5903,
	"./sauteed_peppers.png": 2000,
	"./seafood_curry.png": 348,
	"./seafood_fried_rice.png": 611,
	"./seafood_meuniere.png": 3327,
	"./seafood_paella.png": 1738,
	"./seafood_rice_balls.png": 1957,
	"./seafood_skewer.png": 5510,
	"./seared_gourmet_steak.png": 6706,
	"./seared_prime_steak.png": 5528,
	"./seared_steak.png": 384,
	"./simmered_fruit.png": 9786,
	"./simmered_tomato.png": 7536,
	"./snail_chowder.png": 1187,
	"./sneaky_elixir.png": 9036,
	"./sneaky_river_escargot.png": 772,
	"./spiced_meat_skewer.png": 2181,
	"./spicy_elixir.png": 9865,
	"./steamed_fish.png": 485,
	"./steamed_fruit.png": 4933,
	"./steamed_meat.png": 9434,
	"./steamed_mushrooms.png": 1242,
	"./steamed_tomatoes.png": 5477,
	"./sticky_elixir.png": 2604,
	"./toasted_big_hearty_truffle.png": 4531,
	"./toasted_hearty_truffle.png": 2414,
	"./toasty_brightcap.png": 6002,
	"./toasty_chillshroom.png": 4076,
	"./toasty_endura_shroom.png": 7576,
	"./toasty_hylian_shroom.png": 9990,
	"./toasty_ironshroom.png": 1482,
	"./toasty_razorshroom.png": 2790,
	"./toasty_rushroom.png": 4655,
	"./toasty_silent_shroom.png": 7208,
	"./toasty_skyshroom.png": 1181,
	"./toasty_stamella_shroom.png": 2586,
	"./toasty_sunshroom.png": 992,
	"./toasty_zapshroom.png": 9507,
	"./tomato_mushroom_stew.png": 8770,
	"./tomato_seafood_soup.png": 2933,
	"./tough_elixir.png": 7796,
	"./vegetable_curry.png": 5252,
	"./vegetable_omelet.png": 617,
	"./vegetable_risotto.png": 89,
	"./veggie_cream_soup.png": 7703,
	"./veggie_porridge.png": 7060,
	"./veggie_rice_balls.png": 6235,
	"./wheat_bread.png": 967,
	"./wildberry_crepe.png": 7125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2861;